import { AuthContext } from 'contexts/AuthContext';
import { useContext } from 'react';
import { AuthContextType } from 'components/types/auth';

const useAuth = (): AuthContextType => useContext(AuthContext);

export { useAuth };
